// Force "Comprar Agora" text on the green buy-now button
// (the MPS Buy Me app overwrites the button text at runtime)
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('buy-now-btn');
  if (!btn) return;

  function fixText() {
    if (btn.textContent.trim() !== 'Comprar Agora') {
      btn.textContent = 'Comprar Agora';
    }
  }

  // Fix immediately after load
  fixText();

  // Watch for the app changing the text dynamically
  var observer = new MutationObserver(fixText);
  observer.observe(btn, { childList: true, subtree: true, characterData: true });
});

// Auto-select the first available variant on product page load
// This ensures the Buy Me / checkout redirect app finds a valid variant
// even in fresh browsers where no variant was previously chosen.
document.addEventListener('DOMContentLoaded', function () {
  if (!window.theme || window.theme.pageType !== 'product') return;

  // Use requestAnimationFrame to run AFTER the theme has initialized its
  // section JS and created the hidden input[name="id"] for the form.
  requestAnimationFrame(function () {
    var form = document.querySelector('form.product-form');
    if (!form) return;

    // If the URL already has ?variant=… the user came from a direct link — skip.
    if (window.location.search.indexOf('variant=') !== -1) return;

    // Gather all pre-checked radio buttons (set by Liquid selected_or_first_available_variant).
    var checkedRadios = form.querySelectorAll(
      'input[type="radio"].product-form__single-selector:checked'
    );

    if (checkedRadios.length > 0) {
      // Dispatch a single 'change' on each pre-checked radio so the theme
      // updates input[name="id"] without triggering a double variant-change cycle.
      checkedRadios.forEach(function (radio) {
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // Also handle dropdown-style option selects.
    form.querySelectorAll('select.product-form__single-selector').forEach(function (sel) {
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});